import * as yup from "yup";

export const loginValidator = yup.object().shape({
  userName: yup.string().required("این فیلد الزامی است!"),
  password: yup.string().required("این فیلد الزامی است!"),
});
